// extracted by mini-css-extract-plugin
export var active = "_hi-7";
export var blink = "_hi-8";
export var dropDownSelector = "_hi-4";
export var dropDownWrapper = "_hi-3";
export var fakeCursor = "_hi-6";
export var fontSizeButton = "_hi-9";
export var formQuillEditor = "_hi-0";
export var pressed = "_hi-a";
export var qlBlank = "_hi-1";
export var textFormattingToolbar = "_hi-2";
export var textToolbarOption = "_hi-5";